import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { apiConfig } from "../api/config";
import { visitorAuthStorage } from "../api/authStorage";

function resolveAssetUrl(url: string): string {
  if (/^https?:\/\//i.test(url)) return url;
  const base = apiConfig.baseUrl.replace(/\/$/, "");
  if (url.startsWith("/api/")) {
    if (/^https?:\/\//i.test(base)) {
      const origin = base.replace(/\/api\/v1\/?$/, "");
      return `${origin}${url}`;
    }
    return url;
  }
  if (url.startsWith("/")) return `${base}${url}`;
  return `${base}/${url}`;
}

/** Authenticated fetch → blob URL for guide show_image actions. */
export function GuideAssetImage(props: { url: string; label: string }) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    const token = visitorAuthStorage.getToken();
    const href = resolveAssetUrl(props.url);

    (async () => {
      try {
        const res = await fetch(href, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error(`asset_${res.status}`);
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!cancelled) setSrc(objectUrl);
      } catch {
        if (!cancelled) setError(true);
      }
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [props.url]);

  if (error) {
    return (
      <p className="mt-2 text-[12px] text-amber-700">
        Не удалось загрузить схему «{props.label}».
      </p>
    );
  }
  if (!src) {
    return (
      <div className="mt-2 flex items-center gap-2 text-[12px] text-gray-500">
        <Loader2 size={14} className="animate-spin" /> Схема…
      </div>
    );
  }
  return (
    <a href={src} target="_blank" rel="noopener noreferrer" className="mt-2 block">
      <img
        src={src}
        alt={props.label}
        className="w-full max-h-72 object-contain rounded-xl border border-gray-200 bg-white"
      />
      <span className="mt-1 block text-[11px] text-indigo-700 font-medium">{props.label}</span>
    </a>
  );
}
